import { isStreamIQ, isToya } from '@/shared/lib'

export const getUseVodItems = async () => {
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/features/VOD/hooks/useVodItemsToya')
            return module.useVodItemsToya
        } catch (error) {
            console.warn(
                'useFavoritesChannelsStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/features/VOD/hooks/useVodItemsStreamIQ')
            return module.useVodItemsStreamIQ
        } catch (error) {
            console.warn(
                'useFavoritesChannelsStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
